import { createFormActions, createRequestActions } from '@td/utils';
import {
  PROVIDER_SURGE_INCENTIVE_SEARCH_FORM,
  PROVIDER_SURGE_INCENTIVE_CREATE_FORM,
  PROVIDER_SURGE_INCENTIVE_EDIT_FORM,
  PROVIDER_ACTIVE_SURGE_INCENTIVE_EDIT,
  PROVIDER_UPCOMING_SURGE_INCENTIVE_EDIT,
  PROVIDER_SURGE_INCENTIVE_EDIT,
  PROVIDER_SURGE_INCENTIVE_CREATE_REQUEST,
  PROVIDER_SURGE_INCENTIVE_UPDATE_SEARCH_FILTERS,
  PROVIDER_SURGE_INCENTIVE_SEARCH_REQUEST,
  PROVIDER_SURGE_INCENTIVE_SET_INCENTIVES,
  HIDE_FLASH_MESSAGE,
  SHOW_FLASH_MESSAGE,
  PROVIDER_SURGE_INCENTIVE_DELETE_REQUEST,
  PROVIDER_SURGE_INCENTIVE_EDIT_REQUEST
} from '../action-types';

export const providerSurgeIncentiveSearchForm = createFormActions(
  PROVIDER_SURGE_INCENTIVE_SEARCH_FORM
);

export const providerSurgeIncentiveUpdateSearchFilters = filters => ({
  type: PROVIDER_SURGE_INCENTIVE_UPDATE_SEARCH_FILTERS,
  payload: {
    filters
  }
});

export const providerSurgeIncentiveSetIncentives = (byId, allIds, totalEntries) => ({
  type: PROVIDER_SURGE_INCENTIVE_SET_INCENTIVES,
  payload: {
    byId,
    allIds,
    totalEntries
  }
});

export const providerSurgeIncentiveSearchRequest = createRequestActions(
  PROVIDER_SURGE_INCENTIVE_SEARCH_REQUEST
);

export const providerSurgeIncentiveCreateForm = createFormActions(
  PROVIDER_SURGE_INCENTIVE_CREATE_FORM
);

export const providerSurgeIncentiveCreateRequest = createRequestActions(
  PROVIDER_SURGE_INCENTIVE_CREATE_REQUEST
);

export const providerSurgeIncentiveEditForm = createFormActions(PROVIDER_SURGE_INCENTIVE_EDIT_FORM);

export const providerActiveSurgeIncentiveEdit = surgeIncentive => ({
  type: PROVIDER_ACTIVE_SURGE_INCENTIVE_EDIT,
  payload: {
    surgeIncentive
  }
});

export const providerUpcomingSurgeIncentiveEdit = surgeIncentive => ({
  type: PROVIDER_UPCOMING_SURGE_INCENTIVE_EDIT,
  payload: {
    surgeIncentive
  }
});

export const providerSurgeIncentiveEdit = surgeIncentive => ({
  type: PROVIDER_SURGE_INCENTIVE_EDIT,
  payload: {
    surgeIncentive
  }
});

export const providerSurgeIncentiveDeleteRequest = createRequestActions(
  PROVIDER_SURGE_INCENTIVE_DELETE_REQUEST
);

export const providerSurgeIncentiveEditRequest = createRequestActions(
  PROVIDER_SURGE_INCENTIVE_EDIT_REQUEST
);

export const showFlashMessage = message => ({
  type: SHOW_FLASH_MESSAGE,
  payload: {
    message
  }
});

export const hideFlashMessage = () => ({
  type: HIDE_FLASH_MESSAGE
});
